import type { GuardiaRow } from "../GuardiaTable";

/** Mismo criterio que `isTransportEvent` (views/.../guestTypeUtils): se repite en vez de importarlo
 * porque aquel vive bajo `views/` y estas celdas son componentes comunes. */
const isTransportRow = (row: GuardiaRow): boolean =>
  !!row.event?.authorizationTags?.includes("transport") ||
  (row.event?.transportAuthorizations?.length ?? 0) > 0;

/** Etiqueta del responsable de texto libre: aclara que el acceso lo autorizó el guardia a mano y
 * no un anfitrión del sistema. */
export const formatManualAuthorizer = (name: string): string => `${name} (manual)`;

/**
 * Responsable que autorizó el acceso cuando no hubo un anfitrión: la autorización de transporte la
 * aprobó el guardia por otro medio y el nombre quedó como texto libre. El chofer lo trae en su
 * autorización; el acompañante, en la confirmación en guardia con la que entró (no lleva
 * autorización propia).
 */
export const getTransportAuthorizer = (row?: GuardiaRow): string | undefined => {
  if (!row || !isTransportRow(row)) return undefined;

  const authorizations = row.event?.transportAuthorizations;
  // Igual que `getEntryTransportAuthorization`: manda la autorización de ingreso, que es con la que
  // la persona está adentro. El fallback cubre a los eventos que sólo traen una.
  const authorization =
    authorizations?.find((auth) => auth.eventType === "in") ?? authorizations?.[0];

  const name =
    authorization?.authorizedBy ||
    row.event?.invites?.find((invite: any) => invite?.authorizedBy)?.authorizedBy;

  return name?.trim() || undefined;
};
